import React, {useState} from "react";
import styles from "../SpellChecker.module.css";
import {Brightness1Rounded, ListRounded, PanoramaFishEyeRounded} from "@material-ui/icons";
import {ClickAwayListener, ListItem, Paper, Popper, Tooltip} from "@material-ui/core";
import List from "@material-ui/core/List";

let Element = props => {
    let bullets = {
        bullet1: ` • `,
        bullet2: ` ◦ `,
        none: ``
    }
    let [anchorEl, setAnchorEl] = useState (null)

    return <span><ClickAwayListener onClickAway={ () => {setAnchorEl (null);props.setIsActiveMultilevel(false)} }>
        <span className={props.isDisabled?styles.disabledBtn: styles.btn }
              onMouseDown={ e => {setAnchorEl (e.currentTarget);props.setIsActiveMultilevel(true)} }
        >
        <Tooltip title={ 'Create a bulleted list' }
                 aria-label={ 'bulleted list' }
                 placement={ "top" }
                 disableHoverListener={props.isDisabled}
        >
              { <ListRounded/> }
        </Tooltip>
            <Popper anchorEl={ anchorEl }
                    open={ Boolean (anchorEl) }
                    placement={ "right-start" }
                    className={ styles.menu }
                    hidden={props.isDisabled}
            >
                <List style={ {padding: 0} }>

                        <Paper>
                                <Item onClick={() => props.toggleMultilevel("bullet1", bullets)}
                                      symbol={<Brightness1Rounded className={styles.icon}/>}
                                      label={"Level 1 Bullet"}
                                />
                                <Item onClick={() => props.toggleMultilevel("bullet2", bullets)}
                                      symbol={<PanoramaFishEyeRounded className={styles.icon}/>}
                                      label={"Level 2 Bullet"}
                                />
                            {!props.onlyBulletPoint ? (
                                <Item onClick={() => props.toggleMultilevel("none", bullets)}
                                      label={"None"}
                                />
                            ) : null}
                        </Paper>

                </List>
    </Popper>
    </span></ClickAwayListener>
    </span>
}

export default Element;

let Item = props => {

    return <ListItem button
                     style={ {padding: 0} }
                     onClick={ props.onClick }>
        { props.symbol }
        <span className={ styles.label }>{ props.label }</span>
    </ListItem>
}